import React from 'react';

const TerminosyCondiciones = () => {
  const h2Style = {
    color: '#fdf6d2',
    marginTop: '30px',
    borderBottom: '1px solid rgba(253, 246, 210, 0.3)',
    paddingBottom: '5px',
  };

  const pStyle = {
    textAlign: 'justify',
    textJustify: 'inter-word',
  };

  const advertenciaStyle = {
    fontWeight: 'bold',
    padding: '15px',
    backgroundColor: '#0d292b',
    borderLeft: '5px solid #fdf6d2',
    margin: '20px 0',
  };

  return (
    <div
      style={{
        background: 'linear-gradient(to bottom, #000B18, #133639)',
        minHeight: '100vh',
        color: '#fdf6d2',
        fontFamily: 'Arial, sans-serif',
        lineHeight: 1.6,
        margin: 0,
        padding: '20px',
      }}
    >
      <div
        style={{
          maxWidth: '900px',
          margin: '50px auto',
          padding: '40px',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          borderRadius: '8px',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.5)',
        }}
      >
        <h1
          style={{
            color: '#fdf6d2',
            textAlign: 'center',
            borderBottom: '2px solid #fdf6d2',
            paddingBottom: '15px',
            marginBottom: '5px',
          }}
        >
          TÉRMINOS Y CONDICIONES
        </h1>

        <p style={{ textAlign: 'center', fontStyle: 'italic' }}>
          <strong>Vigente desde: 21 de octubre de 2025</strong>
        </p>

        <p style={pStyle}>
          Estimado cliente, agradecemos su visita y le informamos que al acceder a nuestro sitio{' '}
          <a href="https://umbra.stream" style={{ color: '#fdf6d2', textDecoration: 'underline' }}>
            https://umbra.stream
          </a>{' '}
          (en lo sucesivo, el “Sitio Web”), así como a nuestra plataforma digital disponible en app móvil o en línea a través de algún dispositivo (en lo
          sucesivo, y en conjunto con el Sitio Web, la “Plataforma”) y crear un usuario para acceder a nuestros servicios, se entiende que Usted está enterado
          del presente acuerdo y lo acepta en todos sus términos y condiciones.
        </p>

        <p style={pStyle}>
          Al visitar la Plataforma, Usted queda sujeto(a) a los lineamientos, derechos y restricciones aquí mencionados. La Plataforma es propiedad de VERSATILE
          COMMUNICATIONS, INC. (en adelante, “VERSATILE”) con domicilio ubicado en 9255 Sunset Blvd STE 1100 West Hollywod CA 90069. VERSATILE se reserva el
          derecho, a su sola discreción, de modificar los presentes Términos y Condiciones, siendo efectiva dicha modificación desde el momento de su
          publicación. Es responsabilidad de Usted verificar y consultar los Términos y Condiciones a efecto de poder conocer los cambios o modificaciones
          correspondientes.
        </p>

        <p style={pStyle}>
          Este contrato describe los términos y condiciones generales (los “Términos y Condiciones”) aplicables a nuestros servicios (en lo sucesivo, el
          “Servicio”) en cuanto a la suscripción que usted haga (el “Usuario”) para acceder a una selección de películas, series, documentales, y demás
          contenido audiovisual dentro de la Plataforma para ser visualizado vía satelital, streaming, SVoD, IPTV y demás medios existentes o que lleguen a
          existir. Cualquier persona que desee acceder y/o usar la Plataforma o el Servicio podrá hacerlo sujetándose a los Términos y Condiciones.
        </p>

        <div style={advertenciaStyle}>
          <p style={pStyle}>
            CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES, LOS CUALES TIENEN UN CARÁCTER OBLIGATORIO Y VINCULANTE, DEBERÁ ABSTENERSE DE UTILIZAR
            LA PLATAFORMA. DE LO CONTRARIO, EL USO DE LA PLATAFORMA SE ENTENDERÁ COMO EL TOTAL CONSENTIMIENTO A ESTOS TÉRMINOS Y CONDICIONES.
          </p>
        </div>

        <p style={pStyle}>
          El Usuario se obliga a leer todas las condiciones establecidas en los Términos y Condiciones y en el Aviso de Privacidad, así como en los demás
          documentos incorporados a los mismos por referencia, previos a su registro como Usuario de la Plataforma.
        </p>

        <p style={pStyle}>
          Puede revisar la versión más reciente de los Términos de Servicio en cualquier momento en esta página. Nos reservamos el derecho de actualizar,
          cambiar o reemplazar cualquier parte de estos Términos y Condiciones mediante la publicación de actualizaciones y/o cambios en nuestra Plataforma. Es
          su responsabilidad revisar esta página periódicamente para ver los cambios. Su uso o acceso continuo a la Plataforma después de la publicación de
          cualquier cambio constituye la aceptación de esos cambios.
        </p>

        <h2 style={h2Style}>1. Capacidad.</h2>
        <p style={pStyle}>
          El contenido y Servicio que ofrece la Plataforma está reservado y dirigido únicamente para personas que tengan capacidad legal para contratar. Queda
          bajo responsabilidad de los padres o tutores, supervisar la conducta de los menores de edad que ingresen a la Plataforma.
        </p>

        <h2 style={h2Style}>2. Registro de Usuario.</h2>
        <p style={pStyle}>
          Es obligatorio completar el formulario de datos en todos sus campos con datos válidos para poder utilizar el Servicio que brinda la Plataforma. El
          Usuario deberá completarlo con su información personal de manera exacta, precisa y bajo protesta de decir verdad (los “Datos Personales”), mismos
          Datos Personales que estarán sujetos al tratamiento descrito en el Aviso de Privacidad, mismo que podrá consultar en la liga:
          umbra.stream/privacidad.html.
        </p>

        <p style={pStyle}>
          Proporcionar cualquier información falsa o inexacta, constituye el incumplimiento de estos Términos y Condiciones, lo que podrá configurar una causal
          de rescisión inmediata de la relación jurídica entre las partes.
        </p>

        <p style={pStyle}>
          El Usuario será responsable por todas las operaciones efectuadas con sus Datos Personales, de modo que en este acto libera a VERSATILE de cualquier
          responsabilidad que pueda surgir por un uso indebido o ilícito de sus Datos Personales por terceros ajenos a la presente relación jurídica.
        </p>

        <h2 style={h2Style}>3. Privacidad de la Información.</h2>
        <p style={pStyle}>VERSATILE es responsable de la confidencialidad, uso y protección de la información personal, que nos es proporcionada.</p>

        <p style={pStyle}>
          Para utilizar el Contenido y los Servicios ofrecidos por VERSATILE, los Usuarios deberán facilitar determinados datos de carácter personal, los cuales
          serán utilizados para identificarle y dar cumplimiento a las relaciones comerciales que se realicen, proveerle de los servicios y productos
          adquiridos, y/o informarle sobre las ofertas, promociones y encuestas respecto de nuestros productos. Para mayor información sobre la privacidad de
          los Datos Personales y casos en los que será revelada la información personal, el Usuario podrá consultar el Aviso de privacidad.
        </p>

        <p style={pStyle}>
          Toda la información agregada e información personal que se obtenga del Usuario por el uso de la Plataforma será tratada de manera confidencial, además
          de ser protegida contra cualquier uso indebido, o alteración.
        </p>

        <p style={pStyle}>
          Queda establecido que es decisión del Usuario, otorgar la información personal a VERSATILE. Por lo anterior el Usuario es responsable de la veracidad
          y confiabilidad sobre dicha información.
        </p>

        <p style={pStyle}>
          Para efectos de los dispuesto en los artículos 16, 18 y 18 bis de la Ley Federal de Protección al Consumidor, el Usuario otorga su consentimiento
          expreso y aceptación para recibir información con carácter o fines mercadotécnicos o publicitarios. Del mismo modo, el Usuario faculta a VERSATILE, de
          la forma más amplia que legalmente proceda, para utilizar la Información Personal para resolver controversias o disputas relacionadas con la
          Plataforma y violaciones al presente Convenio.
        </p>

        <p style={pStyle}>
          VERSATILE asegura la confidencial de los datos aportados por los Usuarios, y garantiza que en ningún caso será cedida a terceras empresas ajenas, en
          caso de que el Usuario se oponga a dichos efectos, en los términos del Aviso de Privacidad.
        </p>

        <h2 style={h2Style}>4. Comunicaciones Electrónicas.</h2>
        <p style={pStyle}>
          Cada vez que el Usuario utilice un Servicio de la Plataforma, estará comunicándose electrónicamente con VERSATILE. El Usuario acepta recibir
          comunicaciones de VERSATILE electrónicamente mediante correo electrónico y mensajes colocados en la Plataforma. El Usuario acepta que todos los
          contratos, avisos, mensajes y otras notificaciones y comunicaciones que le enviemos por medios electrónicos satisfacen cualquier requisito legal de
          forma escrita y contarán con los efectos legales y validez que la legislación mercantil le atribuya.
        </p>

        <h2 style={h2Style}>5. Licencia y Acceso.</h2>
        <p style={pStyle}>
          Sujeto al cumplimiento por parte del Usuario a los Términos y Condiciones, así como al pago del precio aplicable para el uso de su membresía dentro de
          la Plataforma, VERSATILE concede una licencia limitada, no exclusiva, revocable, no transferible y no sub-licenciable, de acceso y utilización de la
          Plataforma únicamente para fines personales y no comerciales. Esta licencia no incluye derecho alguno de reventa ni de uso comercial de ninguno de los
          Servicios ni contenidos de la Plataforma; derecho alguno a realizar ningún uso derivado del Servicios de la Plataforma ni de sus contenidos; a
          descargar o copiar información de cuenta alguna para el beneficio de otra empresa; a utilizar tecnología inversa con relación al software utilizado
          por VERSATILE; ni el uso de herramientas o robots de búsqueda y extracción de datos o similar.
        </p>

        <p style={pStyle}>
          No está permitida la reproducción, duplicación, copia, venta, reventa o explotación de ningún tipo de contenido del Servicio de la Plataforma ni de
          parte alguna de los mismos con fines comerciales. Tampoco está permitido colocar o utilizar técnicas de colocación para introducir cualquier marca
          comercial, logotipo u otra información protegida por propiedad industrial o derechos de autor (incluyendo imágenes, texto, diseños de página o
          formatos) sin el consentimiento correspondiente previo por escrito de nosotros.
        </p>

        <p style={pStyle}>
          No está permitido el uso de meta etiquetas (meta tags) ni de ningún otro &quot;texto oculto&quot; que utilice los nombres o marcas de VERSATILE sin
          nuestro consentimiento previo y por escrito. No podrá usted hacer un uso incorrecto del Servicio de VERSATILE. Sólo le está permitido utilizar la
          Plataforma de forma lícita. Cualquier incumplimiento por el Usuario a los Términos y Condiciones supondrá la rescisión de las licencias otorgadas por
          el presente.
        </p>

        <h2 style={h2Style}>6. Información Contenida en el Sitio.</h2>
        <p style={pStyle}>
          El Usuario reconoce y acepta que la información publicada y contenida en la Plataforma será claramente identificada de forma tal que se reconozca que
          la misma es titularidad de VERSATILE.
        </p>

        <p style={pStyle}>
          Las informaciones, conceptos y opiniones publicadas en la Plataforma no necesariamente reflejan la posición de VERSATILE ni de sus empleados,
          oficiales, directores, accionistas, licenciatarios y concesionarios (en lo sucesivo, los “Afiliados”). Por esta razón, no nos hacemos responsables por
          ninguna de las informaciones, opiniones y conceptos que se emitan en la Plataforma o a través de los foros públicos o de cualquier otro espacio o
          servicio que se preste a través de la Plataforma. Asimismo, no nos hacemos responsables de las consecuencias que se puedan derivar del uso de
          consejos, procedimientos, etc., incluidas en alguna página de Internet, en el entendido de que es bajo el propio riesgo y responsabilidad del Usuario
          el uso y seguimiento a dichos consejos, comentarios, procedimientos, tips, etc., que se den en los espacios referidos.
        </p>

        <p style={pStyle}>
          Nos reservamos el derecho de bloquear el acceso o remover en forma parcial o total, toda la información, comunicación o material que a su exclusivo
          juicio pueda resultar: (i) abusivo, difamatorio u obsceno, sexual, racial; (ii) fraudulento, artificioso o engañosos; (iii) violatorio de derechos de
          autor, marcas o cualquier derecho de propiedad intelectual de un tercero; (iv) ofensivo; o (v) de cualquier forma contravenga lo establecido en este
          Convenio.
        </p>

        <h2 style={h2Style}>7. Descripción del Servicio.</h2>
        <p style={pStyle}>
          El Servicio es un servicio en línea que ofrece a sus miembros acceso a Contenido que se transmite vía streaming por Internet, a través de ciertos
          dispositivos. Nos reservamos el derecho, a nuestra absoluta y exclusiva discreción, de hacer cambios en cualquier momento y sin notificación, sobre la
          forma en que manejamos el Servicio, por lo que las descripciones de cómo funciona el Servicio no deben considerarse como una declaración u obligación
          respecto a cómo funcionará en la posteridad.
        </p>

        <h2 style={h2Style}>8. Membresías y Facturación.</h2>
        <p style={pStyle}>
          VERSATILE publicará dentro de la Plataforma las opciones de suscripción y los precios que el Usuario deberá pagar para tener acceso al Contenido
          dentro de la Plataforma, de igual forma, indicará si tienen alguna promoción y/o descuento, vigencia de la misma y el número de piezas disponibles
          para la promoción y/o descuento, así como los medios de pago habilitados para liquidar dichos artículos. De tiempo en tiempo, VERSATILE podrá ofrecer
          promociones o períodos de prueba gratuitos del Servicio, mismos que VERSATILE podrá retirar en cualquier momento, a su entera discreción.
        </p>

        <p style={pStyle}>
          El cargo que se realice para el pago de la membresía será de acuerdo al esquema de suscripción que el Usuario haya elegido al momento de la
          contratación de la membresía, comenzando a facturarse a partir de la fecha de contratación, y sucesivamente por períodos mensuales, semestrales o anuales, respectivamente.
        </p>

        <p style={pStyle}>
          Los pagos realizados por el Usuario no son reembolsables, en el entendido de que no habrá reembolsos o créditos por períodos utilizados parcialmente.
        </p>

        <p style={pStyle}>
          El Usuario podrá, en cualquier momento, cancelar su suscripción. Para efectos de lo anterior, el Usuario entiende que, para el supuesto de que el
          Usuario tenga contratado un plan de pago mensual en la Plataforma, la cancelación de su suscripción podrá realizarse en cualquier momento dentro del
          mes corriente, no obstante, la cancelación del servicio de suscripción surtirá efecto hasta el primer día del mes siguiente a que haya hecho la
          cancelación en cuestión, momento en el que el Usuario dejará de tener acceso al Contenido de la Plataforma y demás beneficios relacionados con su
          membresía. Asimismo, el Usuario entiende y acepta que la Plataforma cuenta con planes de suscripción mensuales, semestrales y anuales, y que 
          NO OTORGAMOS REEMBOLSOS NI CRÉDITOS respecto de plazos contratados, pagados y facturados en favor del Usuario, por lo que en caso de que el Usuario 
          haya contratado cualquiera de los planes de acceso a la Plataforma, incluyendo de forma mensual, semestral o anual, éste conservará su derecho a 
          cancelar su plan en cualquier momento, en el entendido de que no existirá obligación de reembolso alguno en su favor por el plazo adicional 
          no utilizado de los Servicios.
        </p>

        <p style={pStyle}>
          El Usuario reconoce y acepta que, mientras no cancele su suscripción, autoriza expresamente a la Plataforma a realizar cargos automáticos recurrentes 
          conforme al plan contratado, ya sea de manera mensual, semestral o anual, según corresponda.
        </p>

        <h2 style={h2Style}>9. Uso de Dispositivos.</h2>
        <p style={pStyle}>
          Usted reconoce y acuerda que los dispositivos a ser utilizados con el Servicio han sido fabricados y son vendidos por sociedades distintas a
          VERSATILE. Un dispositivo es cualquier equipo electrónico que tiene autorización y capacidad para decodificar películas y programas que se transmiten
          por Internet a través del Servicio. COMO TAL, NO ASUMIMOS NINGUNA RESPONSABILIDAD NI OTORGAMOS NINGUNA GARANTÍA RESPECTO AL DESEMPEÑO DE ESTOS
          DISPOSITIVOS, INCLUYENDO LA COMPATIBILIDAD CONTINUA DEL DISPOSITIVO CON NUESTRO SERVICIO. Al usar nuestro Servicio, usted acuerda en recurrir
          únicamente a la empresa que fabricó y/o le vendió el dispositivo en caso de problemas relacionados con el dispositivo y su compatibilidad con el
          Servicio. Usted además acuerda que, por diversos motivos, como restricciones de los proveedores de contenido y otras limitaciones de terceros, cierto
          Contenido accesible a través de ciertos dispositivos puede no serlo a través de otros. Se bloqueará el acceso al Contenido a los usuarios con
          dispositivos no autorizados. También acuerda que el número de dispositivos a través de los cuales puede ver el Contenido puede cambiar, dependiendo de
          las restricciones que impongan los proveedores de contenido y otros terceros. SE LE PERMITIRÁ VER EL CONTENIDO SIMULTÁNEAMENTE EN DOS DISPOSITIVOS EN
          UN MOMENTO DETERMINADO. Se permitirá al Usuario cambiar dispositivos sin restricciones. El número de dispositivos y de streamings simultáneos pueden
          cambiar sin notificación.
        </p>

        <h2 style={h2Style}>10. Limitaciones Geográficas.</h2>
        <p style={pStyle}>
          Usted puede ver el Contenido a través del Servicio solo en las ubicaciones geográficas donde lo ofrecemos; por tanto, el Contenido que puede estar
          disponible para ser visto variará por ubicación geográfica. VERSATILE utilizará tecnologías para comprobar su ubicación geográfica y con base en la
          determinación de buena fe de dicha ubicación, podrá bloquear cierto Contenido.
        </p>

        <h2 style={h2Style}>11. Prohibiciones.</h2>
        <p style={pStyle}>
          Los Usuarios no podrán: (a) manipular los precios de la membresía; (b) usurpar la identidad de otro Usuario del Sitio; (c) utilizar nuestros Productos
          para ningún fin ilegal o no autorizado ni puede, en el uso del Servicio, violar las leyes de su jurisdicción; (d) transmitir ningún gusano o virus ni
          ningún código de naturaleza destructiva dentro o a través de la Plataforma; (e) violar nuestra propiedad intelectual y/o industrial de cualquier
          forma; (f) hostigar, abusar, insultar, violentar, dañar, difamar, menospreciar, intimidar, amenazar o discriminar a cualquier persona a directa o
          indirectamente mediante la Plataforma; (g) realizar conductas de spam, phishing, rastreo, respaldo o cualquier otra actividad que pretenda recabar
          datos personales de terceros sin su autorización; (h) utilizar la Plataforma, la información y/o el Contenido, para cualquier propósito ilícito o
          ilegal, o bien para solicitar que algún tercero participe en propósitos ilícitos o ilegales.
        </p>

        <p style={pStyle}>
          Este tipo de actividades será investigado por VERSATILE y el infractor podrá ser sancionado con la suspensión o cancelación de la membresía, sin
          perjuicio de las acciones legales a que pueda dar lugar por la configuración de delitos o contravenciones a las disposiciones legales aplicables.
        </p>

        <h2 style={h2Style}>12. Violaciones del Sistema o Bases de Datos.</h2>
        <p style={pStyle}>
          No está permitida acción alguna o uso de dispositivo, software, u otro medio tendiente a interferir tanto en las actividades y operaciones de la
          Plataforma como en las ofertas, descripciones, cuentas o bases de datos de VERSATILE. Cualquier intromisión, tentativa o actividad violatoria o
          contraria a las leyes sobre derecho de propiedad industrial o de derechos de autor y/o a las prohibiciones estipuladas en este contrato, podrá
          encuadrarse en tipo penal.
        </p>

        <h2 style={h2Style}>13. Alcance de los Servicios del Sitio.</h2>
        <p style={pStyle}>Este acuerdo no crea ningún contrato de sociedad, de mandato, de franquicia, o relación laboral entre VERSATILE y el Usuario.</p>

        <h2 style={h2Style}>14. Fallas en el sistema.</h2>
        <p style={pStyle}>
          VERSATILE no se responsabiliza por cualquier daño, perjuicio o pérdida al Usuario causados por fallas en el sistema, en el servidor o en Internet.
          VERSATILE tampoco será responsable por cualquier virus que pudiera infectar el equipo del Usuario como consecuencia del acceso, uso o examen de su
          sitio web o a raíz de cualquier transferencia de datos, archivos, imágenes, textos, o audios contenidos en el mismo. Los Usuarios NO podrán imputarle
          responsabilidad alguna ni exigir pago por lucro cesante, en virtud de perjuicios resultantes de dificultades técnicas o fallas en los sistemas o en
          Internet. VERSATILE no garantiza el acceso y uso continuado o ininterrumpido de su sitio.
        </p>

        <p style={pStyle}>
          El sistema puede eventualmente no estar disponible debido a dificultades técnicas o fallas de Internet, o por cualquier otra circunstancia ajena
          VERSATILE; en tales casos se procurará restablecerlo con la mayor celeridad posible sin que por ello pueda imputársele algún tipo de responsabilidad.
          VERSATILE no será responsable por ningún error u omisión contenido en la Plataforma.
        </p>

        <h2 style={h2Style}>15. Propiedad intelectual.</h2>
        <p style={pStyle}>
          Los contenidos de las pantallas relativas a los servicios de VERSATILE, así como los contenidos audiovisuales, programas, bases de datos, redes,
          archivos que permiten al Usuario acceder y usar su cuenta, son de propiedad y/o están debidamente licenciados por parte de VERSATILE y están
          protegidas por las leyes y los tratados internacionales de derecho de autor, marcas, patentes, modelos y diseños industriales. El uso indebido y la
          reproducción total o parcial de dichos contenidos quedan prohibidos, salvo autorización expresa y por escrito de VERSATILE.
        </p>

        <h2 style={h2Style}>16. Comentarios y Comunicaciones del Usuario.</h2>
        <p style={pStyle}>
          Si, a petición nuestra, envía ciertos datos o comentarios específicos (por ejemplo, participaciones en concursos) o sin una solicitud nuestra, envía
          ideas creativas, sugerencias, propuestas, planes u otros materiales, ya sea en línea, por correo electrónico, por correo postal o de otro modo
          (colectivamente, “Comentarios”), usted acepta que, en cualquier momento, sin restricción, editemos, copiemos, publiquemos, distribuyamos, traduzcamos
          y utilicemos en cualquier medio cualquier Comentario que nos envíe. No tenemos ninguna obligación de: (i) mantener ningún comentario en secreto o
          confidencial; (ii) pagar una compensación por cualquier idea, recomendación o comentario; o (iii) a responder a cualquier comentario.
        </p>

        <p style={pStyle}>
          Podemos, pero no tenemos la obligación de, monitorear, editar o eliminar contenido que a nuestro exclusivo criterio determinamos que son ilegales,
          ofensivos, amenazantes, calumniosos, difamatorios, pornográficos, obscenos o de otra manera objetables o que violan la propiedad intelectual de
          cualquiera de las partes o estos Términos y Condiciones dentro de la Plataforma. Usted acepta que sus comentarios, información o elementos que ingrese
          en la Plataforma no violarán ningún derecho de terceros, incluidos los derechos de autor, marca registrada, privacidad, personalidad u otro derecho
          personal o de propiedad. Además, acepta que sus comentarios no contengan material difamatorio o ilegítimo, abusivo u obsceno, ni contengan ningún
          virus informático u otro malware que pueda afectar el funcionamiento del Servicio o la Plataforma. No puede utilizar una dirección de correo
          electrónico falsa, pretender ser otra persona que no sea usted mismo o, de otro modo, engañarnos a nosotros o a terceros sobre el origen de los
          comentarios. Usted es el único responsable de los comentarios que realice y su exactitud. No asumimos ninguna responsabilidad por los comentarios
          publicados por Usted o un tercero.
        </p>

        <h2 style={h2Style}>17. Errores, Inexactitudes y Omisiones.</h2>
        <p style={pStyle}>
          Ocasionalmente, puede haber información en nuestra Plataforma o en el Servicio que contiene errores tipográficos, imprecisiones u omisiones que pueden
          estar relacionadas con descripciones de Productos, precios, promociones, ofertas, cargos por envío de Productos, tiempos de tránsito y disponibilidad.
          Nos reservamos el derecho de corregir cualquier error, inexactitud u omisión, y cambiar o actualizar información o cancelar pedidos si cualquier
          información en el Servicio o en la Plataforma es incorrecta en cualquier momento sin previo aviso (incluso después de haber enviado su pedido).
        </p>

        <p style={pStyle}>
          No asumimos ninguna obligación de actualizar, modificar o aclarar la información en el Servicio o en la Plataforma, incluyendo, entre otros, la
          información de precios, excepto que lo exija la ley. Ninguna actualización especificada o fecha de actualización aplicada en el Servicio o la
          Plataforma debe tomarse para indicar que toda la información en el Servicio o en la Plataforma ha sido modificada o actualizada.
        </p>

        <h2 style={h2Style}>18. Modificaciones del Acuerdo.</h2>
        <p style={pStyle}>
          VERSATILE podrá modificar los Términos y Condiciones en cualquier momento, haciéndolos públicos en la Plataforma. Todos los términos modificados
          entrarán en vigor al momento de su publicación en la Plataforma.
        </p>

        <h2 style={h2Style}>19. Cesión de Derechos.</h2>
        <p style={pStyle}>
          VERSATILE podrá en cualquier momento, y cuando así lo estime conveniente, ceder total o parcialmente sus derechos y obligaciones derivados del
          presente Convenio. En virtud de dicha cesión, VERSATILE quedará liberado de cualquier obligación a favor del Usuario establecida en el presente
          Convenio.
        </p>

        <h2 style={h2Style}>20. Indemnización.</h2>
        <p style={pStyle}>
          El Usuario está de acuerdo en indemnizar a VERSATILE, así como sus Afiliados, Proveedores, Vendedores y Asesores, de cualquier acción, demanda o
          reclamación (incluso de honorarios de abogados y de costas judiciales) derivadas de cualquier incumplimiento por parte del Usuario al presente
          Convenio.
        </p>

        <h2 style={h2Style}>21. Terminación.</h2>
        <p style={pStyle}>VERSATILE se reserva el derecho, a su exclusiva discreción, y sin necesidad de aviso o notificación para el Usuario, para:</p>

        <p style={pStyle}>
          a) Terminar definitivamente el presente Convenio.
          <br />
          b) Descontinuar o dejar de publicar definitivamente en la Plataforma sin responsabilidad alguna para sí, sus Afiliados o proveedores.
        </p>

        <h2 style={h2Style}>22. Subsistencia.</h2>
        <p style={pStyle}>
          Estos Términos y Condiciones constituyen el acuerdo íntegro entre las Partes y sustituye cualquier otro acuerdo o convenio celebrado con anterioridad.
          Cualesquier cláusula o provisión del presente Convenio, legalmente declarada inválida, será eliminada o modificada, a elección de VERSATILE, a fin de
          corregir su vicio o defecto. Sin embargo, el resto de las cláusulas o provisiones mantendrán su fuerza, obligatoriedad y validez.
        </p>

        <h2 style={h2Style}>23. Ley aplicable y Jurisdicción.</h2>
        <p style={pStyle}>
          La Procuraduría Federal del Consumidor es competente para conocer en la vía administrativa para resolver cualquier controversia que se suscite sobre
          la interpretación o cumplimiento de este contrato.
        </p>

        <p style={pStyle}>
          En lo que respecta a la vía judicial, para la interpretación y cumplimiento de presente contrato las partes se someten a la legislación aplicable en
          los Estados Unidos Mexicanos y a la jurisdicción y competencia de los Tribunales competentes con sede en la Ciudad de México, renunciando expresamente
          a cualquier otro fuero que, por otra razón de sus domicilios o vecindad presentes o futuros, o por cualquier otra causa, pudiera corresponderles.
        </p>
      </div>
    </div>
  );
};

export default TerminosyCondiciones;
